import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReorderInitiationItemsMutationVariables = Types.Exact<{
  input: Types.ReorderInitiationItemsInput;
}>;


export type ReorderInitiationItemsMutation = { __typename?: 'RootMutationType', reorderInitiationItems?: { __typename?: 'ActionResult', userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const ReorderInitiationItemsDocument = gql`
    mutation reorderInitiationItems($input: ReorderInitiationItemsInput!) {
  reorderInitiationItems(input: $input) {
    userErrors {
      field
      message
    }
  }
}
    `;
export type ReorderInitiationItemsMutationFn = Apollo.MutationFunction<ReorderInitiationItemsMutation, ReorderInitiationItemsMutationVariables>;

/**
 * __useReorderInitiationItemsMutation__
 *
 * To run a mutation, you first call `useReorderInitiationItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderInitiationItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderInitiationItemsMutation, { data, loading, error }] = useReorderInitiationItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderInitiationItemsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderInitiationItemsMutation, ReorderInitiationItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderInitiationItemsMutation, ReorderInitiationItemsMutationVariables>(ReorderInitiationItemsDocument, options);
      }
export type ReorderInitiationItemsMutationHookResult = ReturnType<typeof useReorderInitiationItemsMutation>;
export type ReorderInitiationItemsMutationResult = Apollo.MutationResult<ReorderInitiationItemsMutation>;
export type ReorderInitiationItemsMutationOptions = Apollo.BaseMutationOptions<ReorderInitiationItemsMutation, ReorderInitiationItemsMutationVariables>;